var dayjs = require('dayjs')
var timeago = require('timeago.js')

function getTimezone () {
	let offset = new Date().getTimezoneOffset()
	let hours = Math.floor(Math.abs(offset) / 60)
	let minutes = Math.floor(Math.abs(offset) % 60)

	// The time-zone offset is the difference, in minutes, between UTC and local time
	const sign = offset < 0 ? '+' : '-'

	if (hours < 10) {
		hours = '0' + hours
	}

	if (minutes < 10) {
		minutes = '0' + minutes
	}

	return `${sign}${hours}:${minutes}`
}

function isToday (t) {
	return new Date().toDateString() === new Date(t || 0).toDateString()
}

function isYesterday (t) {
	var date = new Date()
	date.setDate(date.getDate() - 1)
	return date.toDateString() === new Date(t || 0).toDateString()
}

function showDateTime (time, dateFormat) {
	let timeMs = getMs(time)
	if (isToday(timeMs)) {
		return dayjs(timeMs).format('HH:mm')
	}
	return dayjs(timeMs).format(dateFormat)
}

var locale = function (number, index, total_sec) {
	return [
		['vừa xong', 'một lúc'],
		['%s giây trước', 'trong %s giây'],
		['1 phút trước', 'trong 1 phút'],
		['%s phút trước', 'trong %s phút'],
		['1 giờ trước', 'trong 1 giờ'],
		['%s giờ trước', 'trong %s giờ'],
		['1 ngày trước', 'trong 1 ngày'],
		['%s ngày trước', 'trong %s ngày'],
		['1 tuần trước', 'trong 1 tuần'],
		['%s tuần trước', 'trong %s tuần'],
		['1 tháng trước', 'trong 1 tháng'],
		['%s tháng trước', 'trong %s tháng'],
		['1 năm trước', 'trong 1 năm'],
		['%s năm trước', 'trong %s năm'],
	][index]
}
timeago.register('vi-VN', locale)

function formatSecondToMinutes (seconds) {
	seconds = Math.floor(seconds)
	let surplus = Math.floor(seconds % 60)
	let minutes = Math.floor(seconds / 60)
	surplus = surplus < 10 ? '0' + surplus : surplus
	minutes = minutes < 10 ? '0' + minutes : minutes
	return minutes + ':' + surplus
}

function offsetToMin (offset) {
	if (!offset) return 0
	if (offset.length <= 2) {
		offset += ':00'
	}
	let sp = offset.split(':')
	if (sp.length !== 2) return 0
	let hour = parseInt(sp[0])
	if (hour < 0 || hour > 23) return 0
	let min = parseInt(sp[1])
	if (min < 0 || min > 59) return 0
	return hour * 60 + min
}

function diffDay (a, b, tzoffset) {
	var offsetmin = -new Date().getTimezoneOffset()
	if (tzoffset) offsetmin = offsetToMin(tzoffset)

	var ams = new Date(a).getTime()
	var bms = new Date(b).getTime()

	var aunixDay = Math.ceil((ams / 60 / 1000 + offsetmin) / 60 / 24)
	var bunixDay = Math.ceil((bms / 60 / 1000 + offsetmin) / 60 / 24)

	return Math.abs(aunixDay - bunixDay)
}

function diffYear (a, b, tzoffset) {
	var machineoffsetmin = -new Date().getTimezoneOffset()

	var offsetmin = -new Date().getTimezoneOffset()
	if (tzoffset) offsetmin = offsetToMin(tzoffset)

	var ams = new Date(a).getTime()
	var bms = new Date(b).getTime()

	var amsInZone = ams + (offsetmin - machineoffsetmin) * 60 * 1000
	var bmsInZone = bms + (offsetmin - machineoffsetmin) * 60 * 1000

	return Math.abs(new Date(amsInZone).getYear() - new Date(bmsInZone).getYear())
}

function sameDay (a, b, tzoffset) {
	return diffDay(a, b, tzoffset) === 0
}

function agoTime (utcms, lang = 'en_US') {
	utcms = getMs(utcms)
	if (lang === 'vi-VN' || lang === 'vi') lang = 'vi-VN'
	return timeago.format(utcms, lang)
}

// convert ms in UTC (+00:00) to short time in tz
function shortTime (utcms, tzoffset, now) {
	var machineoffsetmin = -new Date().getTimezoneOffset()
	var offsetmin = machineoffsetmin
	if (tzoffset) offsetmin = offsetToMin(tzoffset)

	var time = new Date(getMs(utcms))
	var tztime = dayjs(time).add(offsetmin - machineoffsetmin, 'minute') // time in timezone
	if (!now) now = new Date()

	// same day => 05:44
	if (sameDay(time, now, tzoffset)) return dayjs(tztime).format('HH:mm')

	// less than 5 days => FRIDAY, 05:44
	if (diffDay(time, now, tzoffset) <= 5) return dayjs(tztime).format('dddd, HH:mm')

	// over 5 days, same year => SEP 5, 05:44
	if (diffYear(time, now, tzoffset) === 0) return dayjs(tztime).format('MMM D, HH:mm')

	// difference year =>  2019/13/7, 05:44
	return dayjs(tztime).format('YYYY/M/D, HH:mm')
}

function unixSec (t) {
	return Math.floor(getMs(t) / 1000)
}

function getMs (t) {
	if (!t) t = 0
	else if (typeof t !== 'number') t = new Date(t).getTime()

	if (t > 1e18) {
		// nanoseconds
		return Math.floor(t / 1e6)
	}
	if (t > 1e15) {
		// microseconds
		return Math.floor(t / 1e3)
	}
	if (t > 1e12) {
		// milliseconds
		return t
	}
	return t * 1e3 // seconds
}

var sleep = ms => new Promise(res => setTimeout(res, ms))

function getDayName(dayOfWeek) {
	let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	return days[dayOfWeek]
}

module.exports = {
	getMs,
	formatSecondToMinutes,
	sleep,
	unixSec,
	shortTime,
	diffYear,
	diffDay,
	offsetToMin,
	agoTime,
	getTimezone,
	isYesterday,
	showDateTime,
	getDayName,
}
